import React from "react";
import { useAuth } from "../context/AuthContext";

export default function ImpersonationBanner() {
  const { impersonatedBy, stopImpersonating, user } = useAuth();

  if (!impersonatedBy || !user) return null;

  return (
    <div style={styles.bar}>
      <span>
        Viewing as <strong>{user.name || user.email}</strong> ({user.role.replace("_", " ")}) —
        impersonated by {impersonatedBy.email}
      </span>
      <button style={styles.btn} onClick={() => { stopImpersonating(); window.location.href = "/super-admin/users"; }}>
        Return to Admin
      </button>
    </div>
  );
}

const styles = {
  bar: {
    position: "sticky", top: 0, zIndex: 9999,
    display: "flex", alignItems: "center", justifyContent: "center", gap: "16px",
    background: "#F59E0B", color: "#1F1300",
    fontFamily: "'DM Sans','Segoe UI',sans-serif",
    fontSize: "13px", fontWeight: "600",
    padding: "8px 16px",
  },
  btn: {
    background: "#1F1300", color: "#F59E0B",
    border: "none", borderRadius: "6px",
    padding: "4px 12px", fontSize: "12px", fontWeight: "700",
    cursor: "pointer",
  },
};
